<template>
  <!--
  ==========================================================================
  General
  ==========================================================================
  -->
  <form>
    <string-form-field
      :label="$t('person.fields.firstName')"
      required
      :value="value.firstName"
      :disabled="disabled"
      :error="findError('firstName')"
      @input="propertyChange('firstName', $event)"
    />

    <string-form-field
      :label="$t('person.fields.lastName')"
      required
      :value="value.lastName"
      :disabled="disabled"
      :error="findError('lastName')"
      @input="propertyChange('lastName', $event)"
    />

    <string-form-field
      :label="$t('person.fields.email')"
      required
      :value="value.email"
      :disabled="disabled"
      :error="findError('email')"
      @input="propertyChange('email', $event)"
    />
  </form>
</template>
<script>
import EditorMixin from "vue-template/common/mixins/EditorMixin";
import ErrorCounterMixin from "vue-forms/mixins/ErrorCounterMixin";

export default {
  mixins: [EditorMixin, ErrorCounterMixin]
};
</script>
